import { Divider, Space, Tooltip } from 'antd'
import { useTheme } from 'antd-style'

import { ComplaintMemberInfoProps } from './interface'

export const ComplaintMemberInfo = ({ value }: ComplaintMemberInfoProps) => {
  const theme = useTheme()
  const concatStyles = {
    color: theme.colorBgBase
  }
  return (
    <Space>
      {value?.memberName}
      <Tooltip
        styles={{
          root: { maxWidth: 600 }
        }}
        title={
          <Space
            separator={
              <Divider
                orientation='vertical'
                style={{ borderColor: theme.colorBgBase }}
              />
            }
          >
            <span style={concatStyles}>{`联系人：${value?.contactName}`}</span>
            <span
              style={concatStyles}
            >{`联系电话：${value?.contactPhone}`}</span>
            <span style={concatStyles}>
              {`客户经理：${value?.managerName ?? '-'}`}
            </span>
          </Space>
        }
      >
        <span style={{ color: theme.colorLink }}>联系方式</span>
      </Tooltip>
    </Space>
  )
}
